import React from 'react';
import styled from 'styled-components';
import { ProjectContainer, ProjectTitle, ProjectInfo } from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  
  ul.list {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 15px;
      line-height: 24px;
      position: relative;
      padding-left: 20px;
      
      &:before {
        content: '•';
        color: #F34452;
        position: absolute;
        left: 0;
        font-weight: bold;
      }
    }
  }
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;
  
  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }
  
  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
  }
  
  .seeDemo {
    text-align: center;
    margin: 20px 0;
    
    a {
      background: #F34452;
      color: #FFF;
      padding: 12px 30px;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 3px;
      transition: all 0.3s;
      
      &:hover {
        background: #d63946;
      }
    }
  }
  
  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    
    li {
      b {
        color: #333;
      }
    }
  }
`;

interface ProjectVennProps {
}

const ProjectVenn: React.FC<ProjectVennProps> = () => {
  const { t } = useLanguage();
  
  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t('venn.title')}</h2>
        <p className="tags">{t('venn.role')}</p>
      </ProjectTitle>
      
      <ProjectDescription>
        <ul className="list">
          <li>{t('venn.bullet1')}</li>
          <li>{t('venn.bullet2')}</li>
          <li>{t('venn.bullet3')}</li>
          <li>{t('venn.bullet4')}</li>
          <li>{t('venn.bullet5')}</li>
          <li>{t('venn.bullet6')}</li>
          <li>{t('venn.bullet7')}</li>
        </ul>
      </ProjectDescription>
      
      <ProjectInfo>
        <p><b>{t('venn.roleLabel')}</b> {t('venn.myRole')}</p>
        <p><b>{t('venn.skillsLabel')}</b> {t('venn.skillsUtilized')}</p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t('venn.apiTitle')}</h4>
        <img loading="lazy" decoding="async" src="/images/projects/venn-api.webp" className="img-responsive gif" alt="venn api"/>
        <div className="seeDemo">
          <a href="https://api.venn.twosigma.com/docs/index.html#overview" target="_blank" rel="noopener noreferrer">{t('venn.seeMoreWebsite')}</a>
        </div>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t('venn.factorTitle')}</h4>
        <img loading="lazy" decoding="async" src="/images/projects/venn-factor.webp" className="img-responsive gif" alt="venn api"/>
        <div className="seeDemo">
          <a href="https://www.venn.twosigma.com/venn-demo" target="_blank" rel="noopener noreferrer">{t('venn.seeDemo')}</a>
        </div>
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li><b>{t('venn.dateLabel')}</b> {t('venn.dateRange')}</li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectVenn;